import React from 'react';
import styles from './RecordOptionSwitch.module.css';

const RecordOptionSwitch = ({ disabled, options, value, onChange }) => {
  return (
    <div className={styles.record_option_switch}>
      {options.map((opt) => (
        <button
          disabled={disabled}
          key={opt}
          className={value === opt ? styles.active : ''}
          onClick={() => onChange(opt)}
        >
          {opt.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default RecordOptionSwitch;
